export const getInfo = state => state.callStateReducer.info;
export const getMonitorState = state => state.callStateReducer.monitorState;
export const getCallList = state => state.callStateReducer.callList;
export const getCallCustomerNumber = state =>
  state.callStateReducer.customerNumber;
export const getCallCustomerName = state => state.callStateReducer.customerName;
export const getCallStartTime = state => state.callStateReducer.startTime;
export const getCallCurrentTime = state => state.callStateReducer.currentTime;



// WEBPACK FOOTER //
// ./src/store/selector/call.selector.js